export const setStorageItem = (key: string, value: string) => {
  try {
    if (!getStorageItem(key)) {
      localStorage.setItem(key, value);
    }

    return getStorageItem(key);
  } catch (_error) {
    return null;
  }
};

export const getStorageItem = (key: string) => {
  try {
    return localStorage.getItem(key);
  } catch (_error) {
    return null;
  }
};

export const removeStorageItem = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (_error) {}
};

// Unlike setStorageItem, an existing value is always overwritten. Returns the stored value, or null when the
// storage cannot be written.
export const replaceStorageItem = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);

    return getStorageItem(key);
  } catch (_error) {
    return null;
  }
};

// Per-tab storage, cleared when the tab closes.
export const getSessionStorageItem = (key: string) => {
  try {
    return sessionStorage.getItem(key);
  } catch (_error) {
    return null;
  }
};

// Always overwrites an existing value. Returns the stored value, or null when the storage cannot be written.
export const replaceSessionStorageItem = (key: string, value: string) => {
  try {
    sessionStorage.setItem(key, value);

    return getSessionStorageItem(key);
  } catch (_error) {
    return null;
  }
};

export const removeSessionStorageItem = (key: string) => {
  try {
    sessionStorage.removeItem(key);
  } catch (_error) {}
};
